import React, {useState, useContext} from 'react';
import { CustomDropdownContact } from '../utilityComponents/customDropdown';
import { ModalViewPhoto } from '../utilityComponents/customModal';
import { BaseContext } from '../contexts/baseContext';

import img from '../../docs/fondGris.png';

export default function Contact({ contact, message, active }) {
  const [ show, setShow ] = useState("hidden");
  const [ showModal, setShowModal ] = useState(false);
  const { nom, photo, id } = contact;
  const { touchContact } = useContext(BaseContext);

  return (
    <>
      <article
        className={`contact ${active}`}
        onMouseEnter={() => setShow("visible")}
        onMouseLeave={() => setShow("hidden")}
      >
        <div className="contact--image">
          <img src={ img } alt="img" data-src={photo} onClick={() => setShowModal(true)} onMouseOver={() => setShow("hidden")}/>

          <ModalViewPhoto
            show={showModal}
            contact={ contact }
            setClose={() => setShowModal(false)}
          />
        </div>
        <div className="contact--info" onClick={() => touchContact(id)}>
          <span>{ nom.toUpperCase() }</span>
          <span className="text-grey">{ message !== undefined ? message.content:"en ligne" }</span>
        </div>
        <hr />
        <div className="contact--date">
          <small className="text-grey">{ message !== undefined ? message.date:null }</small>

          <CustomDropdownContact
            id={id}
            show={show}
          >
            <i className="bi bi-chevron-down"></i>
          </CustomDropdownContact>
        </div>
      </article>
      <hr className="contact-divider" />
    </>
  );
}
